import type { SpinnerProps } from './spinner.interface';
import type { FC } from 'react';

import cn from 'classnames';
import React from 'react';

const SpinnerMessage = ({ ...rest }) => {
  const messageClass = cn('spinner-message');
  const message = rest.message.trim();

  return message ? <div className={messageClass}>{message}...</div> : <></>;
};

export const Spinner: FC<SpinnerProps> = ({
  isFullSize = false,
  message = '',
}: SpinnerProps) => {
  const spinnerClass = cn(
    'spinner-wrapper',
    isFullSize && 'spinner-wrapper__full',
  );

  return (
    <div className={spinnerClass}>
      <div className={'spinner'} />
      {message && <SpinnerMessage message={message} />}
    </div>
  );
};
